import { render, staticRenderFns } from "./NotShippedGoods.vue?vue&type=template&id=c09f348c&scoped=true"
import script from "./NotShippedGoods.vue?vue&type=script&lang=js"
export * from "./NotShippedGoods.vue?vue&type=script&lang=js"
import style0 from "./NotShippedGoods.vue?vue&type=style&index=0&id=c09f348c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c09f348c",
  null
  
)

export default component.exports